import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { set } from 'date-fns';
import { TableList, Container, Modal, TableListModal } from './styles';

import Table, { IColumn } from '~/components/Table';
import api from '~/services/api';
import { formatPrice } from '~/utils/format';
import { KrClose, KrEye } from '~/components/KoroIcons';
import Loading from '~/components/Loading';

interface ItableValues {
  id: number;
  type: string;
  parcel: number;
  tax_percent: string;
  tax_value: string;
  deadline_koro: number;
  deadline_gateway: number;
}

interface IDataItem {
  id: number;
  id_account: string;
  cnpj: string;
  company_name: string;
  anticipation: boolean;
  table_values: ItableValues[];
}

interface IValue {
  id: number;
  type: string;
  installment: number;
  tax_percent: string;
  tax_price: string;
  koro_deadline: number;
  gateway_deadline: number;
}

interface IGatewayResponse {
  id: number;
  account_id: string;
  anticipation: boolean;
  company: {
    document: string;
    name: string;
    fantasy_name: string;
    support_email: string;
    finance_email: string;
    address: {
      street: string;
      number: string;
      neighborhood: string;
      city: string;
      state: string;
      country: string;
      complement: string;
      zip_code: string;
    };
  };
  values: IValue[];
}

const Gateways: React.FC = () => {
  const [data, setData] = useState<IDataItem[]>([]);
  const [show, setShow] = useState(false);
  const [rowSelected, setRowSelected] = useState({} as IDataItem);
  const [loading, setLoading] = useState(false);

  const handleClose = useCallback(() => {
    setShow(false);
  }, []);

  const handleClick = useCallback((row: IDataItem) => {
    setShow(true);
    setRowSelected(row);
  }, []);

  useEffect(() => {
    setLoading(true);
    api
      .get<IGatewayResponse[]>('gateways')
      .then((response) => {
        const dataGateway = response.data.map<IDataItem>((gateway) => {
          const tableValues = gateway.values.map<ItableValues>((value) => ({
            id: value.id,
            type: value.type,
            parcel: value.installment,
            tax_percent: (parseFloat(value.tax_percent) * 100).toFixed(2),
            tax_value: formatPrice(parseFloat(value.tax_price)),
            deadline_koro: value.koro_deadline,
            deadline_gateway: value.gateway_deadline,
          }));

          return {
            id: gateway.id,
            id_account: gateway.account_id,
            cnpj: gateway.company.document,
            company_name: gateway.company.name,
            anticipation: gateway.anticipation,
            table_values: tableValues,
          };
        });

        setData(dataGateway);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const columns = useMemo<IColumn[]>(
    () => [
      {
        name: 'ID Conta',
        selector: 'id_account',
        sortable: true,
      },

      {
        name: 'CNPJ',
        selector: 'cnpj',
        sortable: true,
      },
      {
        name: 'Empresa',
        selector: 'company_name',
        sortable: true,
      },

      {
        name: 'Antecipação',
        selector: 'anticipation',
        sortable: true,
        cell: (row) => (
          <span>
            {row.anticipation ? (
              <span className="">Sim</span>
            ) : (
              <span className="">Não</span>
            )}
          </span>
        ),
      },

      {
        name: '',
        selector: 'btn',
        sortable: false,
        cell: (row) => (
          <button
            type="button"
            onClick={() => handleClick(row)}
            className="btn-icons border-0"
          >
            <KrEye size={16} color="#fff" />
          </button>
        ),
      },
    ],
    [handleClick]
  );

  const columnsModal = useMemo<IColumn[]>(
    () => [
      {
        name: 'Tipo',
        selector: 'type',
        sortable: true,
      },

      {
        name: 'Parcela',
        selector: 'parcel',
        sortable: true,
      },
      {
        name: 'Taxa %',
        selector: 'tax_percent',
        sortable: true,
      },

      {
        name: 'Taxa R$',
        selector: 'tax_value',
        sortable: true,
      },

      {
        name: 'Prazo Koro',
        selector: 'deadline_koro',
        sortable: true,
      },

      {
        name: 'Prazo Org',
        selector: 'deadline_gateway',
        sortable: true,
      },
    ],
    []
  );

  return (
    <Container>
      <div className="container-fluid">
        <div className="row">
          <div className="zoom col-12 px-0">
            <div className="bg-white d-sm-flex justify-content-between align-items-center p-4">
              <h1 className="mb-0">Gateways</h1>
              {/* <ExportCsv
                data={data}
                columns={columns}
                fileName="Lista_de_eventos"
              /> */}
            </div>
          </div>
          {/* <Filter className="col-12 px-0 mt-3">
            <FiltersLists
              onSubmitFilters={handleSubmitFilters}
              event
              name
              statusEvent
              statusOptions={status}
            />
          </Filter> */}
          <div className="col-12 px-0">
            <div className="row">
              <TableList className="col-12 mt-3">
                <div className="bg-white pb-2">
                  <div className="bg-white overflow-auto">
                    <div className="">
                      <Table
                        className="mb-0 p-0 table"
                        columns={columns}
                        data={data}
                      />
                    </div>
                  </div>
                </div>
              </TableList>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
          <Modal.Title className="mb-0 mt-4">
            <h2 className="title mb-0">Pagamento gateway</h2>
          </Modal.Title>
          <button
            type="button"
            onClick={handleClose}
            className="border-0 bg-transparent"
          >
            <KrClose size={20} color="#989898" />
          </button>
        </Modal.Header>
        <Modal.Body className="pt-0 px-3 px-sm-5">
          <div className="row">
            <div className="col-12">
              <hr />

              <TableListModal className="table-modal">
                <Table columns={columnsModal} data={rowSelected.table_values} />
              </TableListModal>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 pb-4 px-5" />
      </Modal>
      <Loading active={loading} text="Carregando..." />
    </Container>
  );
};

export default Gateways;
